import { useTranslation } from "react-i18next";
import * as Yup from "yup";

export function useCaseShareSchema() {
  const { t } = useTranslation();

  return Yup.object().shape({
    email: Yup.string()
      .email()
      .required(t("label.isRequiredValidation", { field: t("label.email") })),
  });
}
